import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SetupSearch } from 'areas/shared/pages/setup';
import { SearchBox } from 'fw/forms';
import { StatusFilter, NotificationRecipientCombo, NotificationTypeCombo } from 'areas/shared/controls'
import * as API from 'modules/app/API'

class Search extends SetupSearch {

    initialForm() {
        return {
            statusFilter: true,
            searchText: "",
            userTypeCode: "",
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: { type: 'notification' }
        }
    }

    renderForm() {
        return (
            <Row>
                <Col md={4}>
                    <SearchBox
                        name="searchText"
                        placeholder="Search notifications..."
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c}} />
                </Col>
                <Col md={2}>
                    <NotificationTypeCombo name="notificationTypeCode" clearable />
                </Col>
                <Col md={2}>
                    <NotificationRecipientCombo name="userTypeCode" clearable />
                </Col>
                <Col md={2}>
                    <StatusFilter name="statusFilter" onChange={this.search} entity="notifications" />
                </Col>
            </Row>
        )
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/notificationSetup/Search.js